import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { OutlinedInput, MenuItem, Select } from "@material-ui/core";
import { fontControlStyles } from "../../themeEditor_style";

const TextTransform = ({ label, values, name, selected, update, classes }) => {
    const renderValues = values => {
        return values.map(item => {
            return (
                <MenuItem value={item.value} key={item.value}>
                    {item.label}
                </MenuItem>
            );
        });
    };
    const updateValue = (e, selected) => {
        update({ [name]: selected.props.value });
    };

    return (
        <div className={classes.fontSettingsOption}>
            <label>{label}</label>
            <Select
                value={selected}
                onChange={updateValue}
                input={
                    <OutlinedInput
                        labelWidth={0}
                        classes={{
                            root: classes.settingsInput
                        }}
                        name={name}
                    />
                }
            >
                {renderValues(values)}
            </Select>
        </div>
    );
};

export default withStyles(fontControlStyles)(TextTransform);
